const HomeRetouchContent = ({board="a", retouched="before"}) => {
  return (
    <div className={"retouch-content retouch-content-" + board}>
      <div className="rect-back rect-back1"></div>
      <div className="rect-back rect-back2"></div>
      <div className="rect-back rect-back3"></div>
      <div className="rect-back rect-back4"></div>
      <div className="rect-back rect-back5"></div>
      <div className="rect-back rect-back6"></div>
      <div className="rect-back rect-back7"></div>
      <div className='sector-copies'>
        <div className='sector-copies-in'>
          <div className='sector-copy title'>
            <h2 className="copy">photo&nbsp;retouching</h2>
          </div>
          <div className='sector-copy sentance'>
            <p className="copy">
              <span className="span span1"><span className="span-in span-in1">Enhancing & Transforming Photos</span></span><br /><span className="span span2"><span className="span-in span-in2">with a Skilful Touch</span></span>
            </p>
          </div>
        </div>
      </div>
      <div className={"retouch retouch-" + board +" retouch1"}><div className="retouch-in"></div></div>
      <div className={"retouch retouch-" + board +" retouch2"}><div className="retouch-in"></div></div>
      <div className={"retouch retouch-" + board +" retouch3"}><div className="retouch-in"></div></div>
      <div className={"retouch retouch-" + board +" retouch4"}><div className="retouch-in"></div></div>
      <div className={"retouch retouch-" + board +" retouch5"}><div className="retouch-in"></div></div>
      <div className={"retouch-spare retouch-spare-" + board}></div>
    </div>
  )
}

export default HomeRetouchContent;